import {
    CheckBoxTemperatureInstructionFragmentFragment,
    CheckTemperatureInstructionFragmentFragment,
    HotDrinksInstructionFragmentFragment,
    InventoryInstructionFragmentFragment,
    ManualReassortInstructionFragmentFragment,
    MoveProductsInstructionFragmentFragment,
    PhotosInstructionFragmentFragment,
    RemoveProductsInstructionFragmentFragment,
    SetupInstructionFragmentFragment,
    SetupInstructionType,
    StoreProductsInstructionFragmentFragment,
} from '../../../data/__generated__';

export function isCheckTemperatureInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is CheckTemperatureInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.CheckTemperature;
}

export function isCheckBoxTemperatureInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is CheckBoxTemperatureInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.CheckBoxTemperature;
}

export function isHotDrinksInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is HotDrinksInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.HotDrinks;
}

export function isInventoryInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is InventoryInstructionFragmentFragment {
    return (
        instruction.type === SetupInstructionType.InventoryComplete ||
        instruction.type === SetupInstructionType.InventoryCutlery ||
        instruction.type === SetupInstructionType.InventoryDry ||
        instruction.type === SetupInstructionType.InventorySmallExpiryDate ||
        instruction.type === SetupInstructionType.InventoryZero
    );
}

export function isMoveProductsInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is MoveProductsInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.MoveProducts;
}

export function isPhotosInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is PhotosInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.Photos || instruction.type === SetupInstructionType.PhotosStart;
}

export function isRemoveProductsInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is RemoveProductsInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.RemoveProducts;
}

export function isStoreProductsInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is StoreProductsInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.StoreProducts;
}

export function isManualReassortInstruction(
    instruction: SetupInstructionFragmentFragment,
): instruction is ManualReassortInstructionFragmentFragment {
    return instruction.type === SetupInstructionType.ManualReassort;
}
